import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        pageLoading: true //加载动画
    },
    mutations: {
		setPageLoading(state, flag) {
			state.pageLoading = flag
		}
    },
    actions: {
        setPageLoadingAsync({ commit, state }, flag) {
			commit('setPageLoading', flag)
		}
    }
})
